import React from 'react'
import Error from '@components/Error/Error'
import { useAppointmentCalendar } from '@context/AppointmentCalendarContext/AppointmentCalendarContext'
import { AppMode } from '@customTypes/Generic'
import { useConfig } from '@context/ConfigurationContext'
import { GapFillerEmptySlotsMessage } from '@components/GapFiller/EmptySlotsMsg'
import { MultipleClinics } from './components/MultipleClinics/MultipleClinics'
import { isCurrentPeriodUndefined } from '@context/AppointmentCalendarContext/helpers/isCurrentPeriodEmpty'

const AppointmentCalendar = () => {
  const { currentPeriod } = useAppointmentCalendar()
  const { mode } = useConfig()
  const isGapFiller = mode === AppMode.GAP_FILLER

  if (isCurrentPeriodUndefined(currentPeriod)) {
    return isGapFiller ? <GapFillerEmptySlotsMessage /> : <Error />
  }

  return <MultipleClinics />
}

export default AppointmentCalendar
